import { useMemo } from 'react';
import { CrewRanksSummary, SkillTier } from '../types';
import { RANK_TIER_ORDER } from '../constants/rankColors';

export interface OrderedCrewRankTier {
  tier: SkillTier | null;
  code: string;
  count: number;
}

/**
 * ランク別クルー数タイルの表示順・件数を算出する。
 * ホーム画面（CrewRankSummary）とクルー管理画面（CrewManagement）で
 * 同一のロジック・データソース（crew-ranks/summary の count）を使うための共通フック。
 */
export function useCrewRankTiers(summary: CrewRanksSummary | null): OrderedCrewRankTier[] {
  return useMemo(() => {
    if (summary?.tiers && summary.tiers.length > 0) {
      return [...summary.tiers]
        .sort((a, b) => (a.tier?.sort_order ?? 0) - (b.tier?.sort_order ?? 0))
        .map((t) => ({ tier: t.tier, code: t.tier?.code ?? '', count: t.count }));
    }
    return RANK_TIER_ORDER.map((code) => ({ tier: null, code, count: 0 }));
  }, [summary]);
}
